
<template>
  <!-- // 教师培训 -->
  <div>
    <div class="common" v-if="!isRule">
      <div class="tittps" style="font-size: 16px">
        *该栏目支持上传教师参与培训进修所获得的结业证书，由师训条线统一布置的人人都参与的培训项目不必填写。
      </div>
      <!-- 搜索 -->
      <div class="top clearfix">
        <div class="fl">
          搜索：
          <el-input
            style="width: 150px"
            placeholder="请输入关键字"
            v-model="searchKey"
            size="small"
            @change="selectLsit(1)"
            clearable
          >
          </el-input>
          学年：
          <el-date-picker
            class="search-year"
            v-model="searchYear"
            value-format="yyyy"
            size="small"
            type="year"
            @change="selectLsit(1)"
          >
          </el-date-picker>
          学期：
          <el-select
            clearable
            v-model="searchTerm"
            size="small"
            @change="selectLsit(1)"
          >
            <template v-for="i of dic.schoolTerm">
              <el-option
                :key="i.id"
                :label="i.dicName"
                :value="i.dicCode"
              ></el-option>
            </template>
          </el-select>
          类型：
          <el-select
            clearable
            v-model="searchLevel"
            size="small"
            @change="selectLsit(1)"
          >
            <template>
              <el-option
                v-for="item in ruleOptions"
                :key="item.id"
                :label="item.integralName"
                :value="item.integralCode"
              ></el-option>
            </template>
          </el-select>
        </div>
        <div class="fr">
          <el-button
            size="small"
            icon="iconfont icon-daochu"
            @click="importTeacher"
            v-if="isAdmin"
            >导出</el-button
          >
          <el-button size="small" icon="iconfont icon-add" @click="showAddPop"
            >新增</el-button
          >
          <icon-integral-rule
            :isRule="isRule"
            @openRule="isRule = true"
          ></icon-integral-rule>
        </div>
      </div>
      <!-- 表格 -->
      <el-table
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 0.9)"
        v-loading="isTableLoading"
        row-key="id"
        :data="tableData"
        stripe
        style="width: 100%"
        :header-cell-style="{ background: '#EFEFEF' }"
      >
        <el-table-column prop="schoolYear" label="学年" width="60">
        </el-table-column>
        <el-table-column prop="schoolTermDesc" label="学期"> </el-table-column>
        <el-table-column prop="teacherName" label="教师"> </el-table-column>
        <el-table-column prop="trainingName" label="证书名称">
        </el-table-column>
        <el-table-column prop="trainingType1Desc" label="进修类型">
        </el-table-column>
        <el-table-column prop="trainingType2Desc" label="等级">
        </el-table-column>

        <el-table-column label="附件" width="60">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="
                showImg(
                  scope.row.trainingAttaches[0].url,
                  null,
                  scope.row.trainingAttaches
                )
              "
              >查看</el-button
            >
          </template>
        </el-table-column>
        <el-table-column prop="trainingDate" label="上传日期" width="130">
        </el-table-column>
        <el-table-column prop="score" label="获得积分"> </el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button
              :disabled="isDisabled(scope)"
              type="text"
              class="text-edit"
              @click="showEdit(scope.$index, scope.row)"
              >编辑</el-button
            >|
            <el-button
              :disabled="isDisabled(scope)"
              type="text"
              class="text-del"
              @click="showDelPop(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination
        :pageObj="pageObj"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      ></pagination>

      <!-- 删除的对话框 -->
      <popup-del :delVisible="delVisible" @close="closePopupDel"></popup-del>

      <!-- 新增的对话框 -->
      <el-dialog
        class="add-pop"
        title="新增"
        :visible.sync="addVisible"
        :close-on-click-modal="false"
        width="40%"
        top="5%"
      >
        <template v-slot:title>
          <div class="add-title">{{ form.id ? "编 辑" : "新 增" }}</div>
        </template>
        <!-- 对话框内容部分 => 匿名插槽 -->
        <el-form ref="form" :rules="rules" :model="form" label-width="80px">
          <el-form-item label="学年" prop="schoolYear">
            <el-date-picker
              class="width-form-input"
              v-model="form.schoolYear"
              value-format="yyyy"
              type="year"
              placeholder="请选择"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="学期" prop="schoolTerm">
            <el-select v-model="form.schoolTerm" placeholder="请选择">
              <template v-for="i of dic.schoolTerm">
                <el-option
                  :key="i.id"
                  :label="i.dicName"
                  :value="i.dicCode"
                ></el-option>
              </template>
            </el-select>
          </el-form-item>
          <!-- 教师姓名 -->
          <el-form-item label="教师" prop="teacherId">
            <el-select
              v-model="form.teacherId"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键字"
              :remote-method="teacherKeyChange"
              :loading="teacherLoading"
            >
              <el-option
                v-for="item in teacherOptions"
                :key="item.id"
                :label="
                  item.teacherNum
                    ? item.userName + '(师训号:' + item.teacherNum + ')'
                    : item.userName
                "
                :value="item.userId"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- 类型 -->
          <el-form-item label="类型" prop="ruleList">
            <el-cascader
              @change="getIntegralNum"
              class="width-form-input"
              :props="defaultProps"
              v-model="form.ruleList"
              :options="ruleOptions"
            ></el-cascader>
          </el-form-item>

          <el-form-item label="证书名称" prop="trainingName">
            <el-input
              v-model="form.trainingName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item label="上传附件" prop="trainingAttaches">
            <upload
              :limit="10"
              v-if="addVisible"
              :allowType="1"
              :fileLimit="50"
              :fileList="form.trainingAttaches"
              :fileUrl="form.trainingAttach"
              @uploadFileUrl="uploadFileUrl"
            ></upload>
          </el-form-item>
        </el-form>

        <template v-slot:footer>
          <span class="dialog-footer">
            <el-button @click="submitStudent" type="primary">提 交</el-button>
          </span>
        </template>
      </el-dialog>

      <!-- 图片预览弹框 -->
      <ViewImg :img-path-list="imgPathList" :is-show.sync="imgVisible" />
    </div>

    <div v-else>
      <integral-rule-view @closeRule="isRule = false"></integral-rule-view>
    </div>
  </div>
</template>

<script>
import PopupDel from "@/components/PopupDel.vue";
import IconIntegralRule from "@/components/IconIntegralRule.vue";
import IntegralRuleView from "@/components/IntegralRuleView.vue";
import Pagination from "@/components/Pagination.vue";
import Upload from "@/components/Upload.vue";
import { exportExecl, getCurrentDate } from "@/utils/index";
import { mapState } from "vuex";
import { mixin } from "@/mixin/mixin";
import ViewImg from "@/components/ViewImg.vue";
export default {
  mixins: [mixin],
  components: {
    PopupDel,
    IconIntegralRule,
    IntegralRuleView,
    Upload,
    Pagination,
    ViewImg,
  },
  computed: {
    ...mapState([
      "isAdmin",
      "userInfo",
      "dic",
      "teacherOptions",
      "teacherLoading",
      "ruleOptions",
      "ruleOptionsList",
    ]),
  },
  data() {
    return {
      isRule: false,
      isTableLoading: false,
      searchYear: "",
      searchTerm: "",
      tableData: [],
      selectRow: null,
      searchKey: "",
      defaultProps: {
        children: "child",
        label: "integralName",
        value: "integralCode",
      },
      delVisible: false,
      addVisible: false,
      searchLevel: "",

      form: {
        id: "",
        operatorId: "",
        schoolYear: "",
        schoolTerm: "",
        trainingDate: "",
        trainingName: "",
        ruleList: "",
        score: "",
        teacherId: "",
        teacherName: "",
        trainingAttach: "",
        trainingAttaches: [],
        trainingType: 1, //培训  1进修
      },
      rules: {
        schoolYear: [
          {
            required: true,
            message: "请选择学年",
            trigger: ["change", "blur"],
          },
        ],
        teacherId: [
          {
            required: true,
            message: "请选择教师",
            trigger: ["change", "blur"],
          },
        ],
        teacherName: [
          {
            required: true,
            message: "教师名称不符合规范",
            trigger: ["change", "blur"],
          },
        ],
        schoolTerm: [
          {
            required: true,
            message: "请选择学期",
            trigger: ["change", "blur"],
          },
        ],
        ruleList: [
          {
            required: true,
            message: "请选择类型",
            trigger: ["change", "blur"],
          },
        ],
        trainingName: [
          {
            required: true,
            message: "请输入证书名称名称",
            trigger: ["change", "blur"],
          },
          {
            min: 1,
            max: 50,
            message: "长度在 1 到 50 个字符",
            trigger: ["change", "blur"],
          },
        ],
        trainingAttaches: [
          {
            required: true,
            message: "请选择附件",
            trigger: ["change", "blur"],
          },
        ],
      },
      pageObj: {
        current: 1,
        total: 0,
        size: 10,
        sizeList: [10, 15, 20, 25, 30],
      },
      //判断资源名称是否发生改变
      teptrainingAttach: "",
    };
  },
  created() {
    this.searchYear = "";
    this.searchTerm = "";
    let { menuCode } = this.userInfo.menuInfoList.find(
      (item) => this.$route.path.indexOf(item.menuCode) != -1
    );
    this.$store.dispatch("getRuleOptions", menuCode); //积分规则下拉列表,获奖分类
    this.selectLsit(1); //首页list
  },
  methods: {
    //教师选择的列表
    teacherKeyChange(keyword) {
      keyword != "" && this.$store.dispatch("getTeacherOptions", keyword);
    },
    //首页 查询首页list
    selectLsit(curPage, pageSize) {
      let homeForm = {
        schoolCode: this.userInfo.schoolCode,
        clientPackage: "com.xueduoduo.teacher.archives.pc",
        pageNum: curPage || this.pageObj.current,
        pageSize: pageSize || this.pageObj.size,
        schoolTerm: this.searchTerm || "",
        schoolYear: this.searchYear || "",
        keyword: this.searchKey || "",
        trainingType1: this.searchLevel || null,
        isAdmin: this.isAdmin / 1,
        operatorId: this.userInfo.userId,
      };
      this.isTableLoading = true;
      this.$axios
        .post("/teacherTraining/getTeacherEducationList", homeForm)
        .then((res) => {
          if (res.resultCode === 200) {
            this.pageObj.size = res.data.size;
            this.pageObj.current = res.data.current;
            this.pageObj.total = res.data.total;
            this.tableData = res.data.records;
          } else {
            this.$message({
              message: "网络错误",
              type: "error",
            });
          }
          this.isTableLoading = false;
        })
        .catch((err) => {
          console.log("教师error", err);
        });
    },
    //导出
    importTeacher() {
      exportExecl(
        "/exp/expTeacherEducation",
        "教师进修-" + this.userInfo.userName,
        this.userInfo.schoolCode,
        this.pageObj.current,
        this.pageObj.size,
        this.searchYear,
        this.searchTerm,
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        this.searchLevel
      );
    },

    // 获得积分
    getIntegralNum() {
      this.recursion(this.ruleOptions);
    },
    //递归
    recursion(arr) {
      arr.forEach((item) => {
        if (item.child && item.child.length > 0) {
          this.recursion(item.child);
          return;
        }
        if (
          item.integralCode ===
          this.form.ruleList[this.form.ruleList.length - 1]
        ) {
          this.form.score = item.integralNum;
        }
      });
    },
    //编辑
    showEdit(index, row) {
      this.selectRow = row;
      //重置效验样式
      this.$refs.form && this.$refs.form.resetFields();
      //查询教师的选择
      this.teacherKeyChange(row.teacherName);

      //判断文件是否发生了改变，从而更改上传时间
      this.teptrainingAttach = row.trainingAttach;
      this.form = {
        id: row.id,
        schoolYear: row.schoolYear + "",
        schoolTerm: row.schoolTerm + "",
        trainingDate: row.trainingDate,
        trainingName: row.trainingName,
        trainingType: row.trainingType,
        ruleList: [row.trainingType1, row.trainingType2],
        score: row.score,
        teacherId: row.teacherId,
        teacherName: row.teacherName,
        trainingAttach: row.trainingAttach,
        trainingAttaches: row.trainingAttaches,
      };
      this.isInclude(this.ruleOptionsList, this.form.ruleList)
        ? ""
        : (this.form.ruleList = []);
      this.getIntegralNum();
      this.addVisible = true;
    },
    // 删除 弹框
    showDelPop(index, row) {
      this.selectRow = row;
      this.delVisible = true;
    },
    // 删除弹框 关闭
    closePopupDel(status) {
      if (status) {
        let del = {
          clientPackage: "com.xueduoduo.teacher.archives.pc",
          id: this.selectRow.id,
          operatorId: this.userInfo.userId,
        };
        this.$axios
          .post("/teacherTraining/deleteTeacherTrainingInfo", del)
          .then((res) => {
            if (res.resultCode === 200) {
              this.selectLsit(this.pageObj.current, this.pageObj.size),
                this.$message({
                  message: "删除成功",
                  type: "success",
                  duration: 2000,
                  offset: 150,
                });
            } else {
              console.log("del else", res);
            }
          })
          .catch((err) => {
            console.log("del error", err);
          });
        this.delVisible = false;
      } else {
        this.delVisible = false;
      }
    },
    //分页
    handleSizeChange(pageSize) {
      this.pageObj.size = pageSize;
      this.selectLsit(1, pageSize);
    },
    handleCurrentChange(curPage) {
      this.selectLsit(curPage);
    },
    // 新增
    showAddPop() {
      //清空form表单
      this.form = {
        id: "",
        operatorId: "",
        schoolYear: "",
        schoolTerm: "",
        trainingDate: "",
        trainingName: "",
        ruleList: "",
        score: "",
        teacherId: "",
        teacherName: "",
        trainingAttach: "",
        trainingAttaches: [],
        trainingType: 1, //培训  1进修
      };
      this.$refs.form && this.$refs.form.resetFields();
      this.addVisible = true;
    },
    //新增 或者 更新
    submitStudent() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.id) {
            //更新
            this.form.operatorId = this.userInfo.userId;
            this.form.schoolCode = this.userInfo.schoolCode;
            if (this.teptrainingAttach != this.form.trainingAttach) {
              //判断资源名是否发生改变，更新上传的时间
              this.form.trainingDate = getCurrentDate(1);
            }
            [this.form.trainingType1, this.form.trainingType2] =
              this.form.ruleList;
            this.$axios
              .post("/teacherTraining/updateTeacherTrainingInfo", this.form)
              .then((res) => {
                if (res.resultCode === 200) {
                  //重置表单
                  this.$refs.form.resetFields();
                  this.selectLsit(this.pageObj.current, this.pageObj.size);
                  this.$message({
                    message: "更新成功",
                    type: "success",
                    duration: 2000,
                    offset: 150,
                  });
                } else {
                  console.log("update else", res);
                }
                this.addVisible = false;
              })
              .catch((err) => {
                console.log("update error", err);
              });
          } else {
            //保存
            this.form.operatorId = this.userInfo.userId;
            this.form.schoolCode = this.userInfo.schoolCode;
            [this.form.trainingType1, this.form.trainingType2] =
              this.form.ruleList;
            if (this.form.trainingAttach) {
              //有文件则更新上传的时间
              this.form.trainingDate = getCurrentDate(1);
            }
            console.log("this。for", this.form);
            this.$axios
              .post("/teacherTraining/saveTeacherTrainingInfo", this.form)
              .then((res) => {
                if (res.resultCode === 200) {
                  //重置表单
                  this.$refs.form.resetFields();
                  this.selectLsit(this.pageObj.current, this.pageObj.size);
                  this.$message({
                    message: "保存成功",
                    type: "success",
                    duration: 2000,
                    offset: 150,
                  });
                } else {
                  this.$message({
                    message: res.msg,
                    type: "success",
                    duration: 2000,
                    offset: 150,
                  });
                }
                this.addVisible = false;
              })
              .catch((err) => {
                console.log("update error", err);
              });
          }
        }
      });
    },
    //资源路径
    uploadFileUrl(fileUrl, fileList) {
      this.form.trainingAttaches = fileList;
      this.form.trainingAttach = fileUrl;
    },
  },
  watch: {
    "form.teacherId"(newValue) {
      if (newValue && this.teacherOptions) {
        let teacherObj = this.teacherOptions.find(
          (item) => item.userId === newValue
        );
        this.form.teacherName = teacherObj && teacherObj.userName;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../styles/common.less";
</style>
